import { createElement, MouseEvent } from 'react';

export function formatTextWithHashtags(text: string): JSX.Element[] {
  const hashtagRegex = /#[\w]+/g;
  const parts = text.split(hashtagRegex);
  const hashtags = text.match(hashtagRegex) || [];
  const result: JSX.Element[] = [];

  parts.forEach((part, index) => {
    if (part) {
      result.push(
        createElement('span', { key: `text-${index}` }, part)
      );
    }
    if (hashtags[index]) {
      result.push(
        createElement('a', {
          key: `hashtag-${index}`,
          href: `/hashtag/${hashtags[index].slice(1)}`,
          className: 'text-[#728c00] hover:text-[#5e7300] dark:text-[#728c00] dark:hover:text-[#86a500]',
          onClick: (e: MouseEvent) => {
            e.preventDefault();
            // Save current scroll position
            sessionStorage.setItem('scrollPosition', window.scrollY.toString());
            // Navigate to hashtag page
            window.location.href = `/hashtag/${hashtags[index].slice(1)}`;
          }
        }, hashtags[index])
      );
    }
  });

  return result;
}
